import { authClient } from "./auth-client";

export const sendMagicLink = async (name: string, email: string) => {
  const { error } = await authClient.signIn.magicLink({
    email: email,
    name: name,
  });
  if (error) {
    console.error(error);
  }
};

export const signInGoogle = async () => {
  await authClient.signIn.social({
    provider: "google",
  });
};
